/**
 * Asynchronously loads the component for ConfirmBooking
 */
import { lazyRoute } from 'components/LazyRoute'

export default lazyRoute(() => import('./index'))
